import { LockSolidIcon } from '@tableau/icons/LockSolidIcon';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';

import { CollectionPrivateHeader } from './CollectionSpace';

export const CollectionsPrivateIndicatorIdPrefix = 'collections-private-indicator';
export function CollectionsCardPrivateIndicator() {
    return (
        <div className={CardViewStyles.PrivateCollectionArea}>
            <LockSolidIcon size={14} alt='' />
            <span className={CardViewStyles.PrivateCollectionText}>{Messages.collectionVisibilityPrivate()}</span>
      </div>
    );
}

// Used for collection space header and list view
export function CollectionsPrivateIndicator() {
  return (
    <div data-tb-test-id={CollectionPrivateHeader}>
      <LockSolidIcon size={14} alt='' />
      <span style={{ marginLeft: 2 }}>{Messages.collectionVisibilityPrivate()}</span>
    </div>
  );
}
